import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/app.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

// When you're ready to configure Amplify, uncomment these lines:
// import { Amplify } from 'aws-amplify';
// Amplify.configure({
//   // AWS Amplify configuration will go here
// });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);